import * as Yup from "yup";

export const sealRegistrationSchema = Yup.object({
  fullName: Yup.string().required("Enter your full name."),
  jobTitle: Yup.string().required("Enter your job title or role."),
  email: Yup.string()
    .required("Enter a valid email address.")
    .email("Enter a valid email address."),
  confirmEmail: Yup.string()
    .required("Confirm your email address.")
    .oneOf([Yup.ref("email")], "Email addresses do not match."),
  legalOrganizationName: Yup.string().required(
    "Enter the legal organization name."
  ),
  registeredName: Yup.string().required("Enter the name being registered."),
  organizationWebsite: Yup.string().required("Enter a website."),
  organizationCountry: Yup.string().required("Enter a country."),
  roles: Yup.object().test(
    "at-least-one-role",
    "Select at least one role.",
    (value) =>
      value != null && Object.values(value).some((v) => v === true)
  ),
  intendedUse: Yup.object().test(
    "at-least-one-use",
    "Select at least one intended use.",
    (value) =>
      value != null && Object.values(value).some((v) => v === true)
  ),
  packagingConfirmation: Yup.boolean().when("intendedUse", {
    is: (intendedUse: Record<string, boolean>) => intendedUse?.packaging,
    then: (schema) =>
      schema.oneOf(
        [true],
        "This confirmation is required to select packaging use."
      ),
    otherwise: (schema) => schema,
  }),
  vineyardUrls: Yup.array()
    .of(
      Yup.object({
        value: Yup.string().test(
          "valid-vineyard-url",
          "URL must match the pattern: https://oldvineregistry.org/vineyard/Name_Producer_Year",
          (value) =>
            !value ||
            value.trim() === "" ||
            /^https?:\/\/(www\.)?oldvineregistry\.org\/vineyard\/.+_.+_.+$/.test(
              value.trim()
            )
        ),
      })
    )
    .test(
      "at-least-one-url",
      "Enter at least one Old Vine Registry vineyard URL.",
      (value) =>
        value != null &&
        value.some((item) => item.value != null && item.value.trim() !== "")
    ),
  attestationsChecked: Yup.array()
    .of(Yup.boolean())
    .test(
      "all-checked",
      "All attestations must be confirmed.",
      (value) => value != null && value.every((v) => v === true)
    ),
  agreeToTerms: Yup.boolean().oneOf(
    [true],
    "You must agree to the license terms to continue."
  ),
  communicationsRequired: Yup.boolean().oneOf(
    [true],
    "This acknowledgment is required to continue."
  ),
});
